import { Model } from '@/services/api/lib'
import { TaxRate, TaxGroup, VAT } from './taxes'
import { Settings, GeneralSettings, ContactAddress, Country } from './settings'
import Store from './store'
import Zone from './zone'
import Shipping from './shipping'
import Territory from './territory'
import Language from './languages'
import StateMachine from '@/modules/Settings/models/stateMachine'
import Notification from './notification'

class PaymentMethods extends Model {
  resource () {
    return 'payments/v1/methods'
  }

  updateMethod () {
    return (this.isNew) ? 'POST' : 'PUT'
  }

  isOffline () {
    return this.provider === 'Futureecom\\Payments\\App\\Methods\\Offline' && this.integrated === false
  }

  async save (config = {}) {
    if (!this.hasId() && this.name && !this.code) {
      this.code = this.name.toLowerCase().replace(/\s+/g, '_').replace(/[^\w-]+/g, '')
    }

    return super.save(config)
  }

  defaults () {
    return {
      translations: null
    }
  }

  cleanErrors () {
    this.errors.map(error => {
      error.message = error.message.map(message => {
        message = message.replace(error.field, 'field')
        return message
      })
    })
  }

  validations () {
    return this.validatorSchema || {}
  }
}

class Abilities extends Model {
  resource () {
    return 'settings/v1/abilities'
  }
}

export default {
  Store,
  Zone,
  Territory,
  TaxRate,
  TaxGroup,
  VAT,
  GeneralSettings,
  Shipping,
  Language,
  PaymentMethods,
  Abilities,
  ContactAddress,
  Settings,
  Country,
  StateMachine,
  Notification
}
